import * as AppPics from 'assets/images';
import { memo, useState } from 'react';
import ReorderBlocks from '../../ReorderBlocks';

function BlocksImageTypes({ type, imageProps = {} }) {
  if (type === 'text')
    return <img src={AppPics.TextSvg} alt="add text block content" {...imageProps} />;
  if (type === 'image')
    return <img src={AppPics.ImageSvg} alt="add multi media block content" {...imageProps} />;
  if (type === 'equation') return <img src={AppPics.EquationSvg} alt="" {...imageProps} />;
  if (type === 'problem') return <img src={AppPics.ProblemSvg} alt="" {...imageProps} />;
  if (type === 'tip') return <img src={AppPics.TipSvg} alt="" {...imageProps} />;
  if (type === 'box') return <img src={AppPics.BoxSvg} alt="" {...imageProps} />;
  if (type === 'video') return <img src={AppPics.VideoSvg} alt="" {...imageProps} />;
  if (type === 'audio') return <img src={AppPics.AudioSvg} alt="" {...imageProps} />;
  if (type === 'file') return <img src={AppPics.FileSvg} alt="" {...imageProps} />;

  return null;
}

function BlocksList({ handleChange }) {
  return (
    <div className="contentbuttonsection">
      <Box onClick={() => handleChange('text')}>
        <span className="icon">
          <img src={AppPics.TextSvg} alt="add text block content" />
        </span>
        <span className="label">Text</span>
      </Box>
      <Box onClick={() => handleChange('image')}>
        <span className="icon image">
          <img src={AppPics.ImageSvg} alt="add multi media block content" />
        </span>
        <span className="label">Image</span>
      </Box>
      <Box onClick={() => handleChange('equation')}>
        <span className="icon">
          <img src={AppPics.EquationSvg} alt="" />
        </span>
        <span className="label">Equation</span>
      </Box>
      <Box onClick={() => handleChange('problem')}>
        <span className="icon">
          <img src={AppPics.ProblemSvg} alt="" />
        </span>
        <span className="label">Problem</span>
      </Box>
      <Box onClick={() => handleChange('tip')}>
        <span className="icon">
          <img src={AppPics.TipSvg} alt="" />
        </span>
        <span className="label">Tip</span>
      </Box>
      <Box onClick={() => handleChange('box')}>
        <span className="icon">
          <img src={AppPics.BoxSvg} alt="" />
        </span>
        <span className="label">Box</span>
      </Box>
      <Box onClick={() => handleChange('video')}>
        <span className="icon video">
          <img src={AppPics.VideoSvg} alt="" />
        </span>
        <span className="label">Video</span>
      </Box>
      <Box onClick={() => handleChange('audio')}>
        <span className="icon audio">
          <img src={AppPics.AudioSvg} alt="" />
        </span>
        <span className="label">Audio</span>
      </Box>
      <Box onClick={() => handleChange('file')}>
        <span className="icon file">
          <img src={AppPics.FileSvg} alt="" />
        </span>
        <span className="label">File</span>
      </Box>
    </div>
  );
}

function Box({ children, ...props }) {
  return (
    <a className="buttonfield" {...props}>
      {children}
    </a>
  );
}

function AppBlocks(props) {
  const { handleChange, reorderSettings } = props;
  const { showReorderBlock, blocks, type, checkPrerequisite, handleSubmission } =
    reorderSettings || {};

  const [blockSection, showBlockSection] = useState(false);
  const [reOrderModal, setReOrderModal] = useState({ open: false, data: {} });

  return (
    <>
      {reOrderModal.open && (
        <ReorderBlocks
          open={reOrderModal.open}
          closeModal={() => {
            setReOrderModal({ open: false, data: {} });
          }}
          data={{
            blocks,
            type,
            handleSubmission: (args = {}) => {
              args.cb = () => setReOrderModal({ open: false, data: {} });
              handleSubmission(args);
            },
          }}
        />
      )}
      <div className="row contentaddbtnouter">
        <div className="col-12">
          <div className="addcontent">
            <a
              href="#"
              className="addsymbol"
              role={'button'}
              onClick={(event) => {
                event.preventDefault();
                showBlockSection(true);
              }}
            >
              +
            </a>
            {showReorderBlock && (
              <a
                href="#"
                className="addsymbol"
                role={'button'}
                onClick={(event) => {
                  event.preventDefault();

                  const { canGoForward } = checkPrerequisite?.() ?? {};
                  if (!canGoForward) {
                    window.alert('Please save the changes first and then proceed to reordering!');
                    return;
                  }

                  setReOrderModal({ open: true, data: {} });
                }}
                style={{ left: '65px' }}
              >
                <img src={AppPics.ReorderPng} alt="re-order contents" width={16} />
              </a>
            )}

            {blockSection && (
              <BlocksList
                handleChange={(data) => {
                  handleChange(data);
                  showBlockSection(false);
                }}
              />
            )}

            {/*  */}
          </div>
        </div>
      </div>
    </>
  );
}

export { BlocksImageTypes };
export default memo(AppBlocks);
